import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';
import VerificationSection from './components/VerificationSection';

// SettingsPage 属于按需加载的 chunk，必须用模块路径字符串让 extend 走 reg.onLoad
const SETTINGS_PAGE = 'flarum/forum/components/SettingsPage';

// Material 风格 verified 图标（内联 SVG，自托管）
const VERIFIED_PATH = 'M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82 1.89 3.2L12 21.04l3.4 1.46 1.89-3.2 3.61-.82-.34-3.69L23 12zm-12.91 4.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z';
const tooltip = () => {
  const locale = app.translator && app.translator.locale || 'zh-Hans';
  return locale === 'en' ? 'Community-verified member (self-attested, not an official school endorsement)' : '社区验证校友（社区自助核验，非学校官方认证）';
};
app.initializers.add('kapok-plus-verified-badge', () => {
  // users.is_scut_verified → user.isScutVerified()
  User.prototype.isScutVerified = Model.attribute('isScutVerified');

  /**
   * 金标：加在 User 的 badges 列表里，帖子头部、用户卡片、资料页会一并显示。
   * 使用 Material 风格 verified 图标（自定义 UI 不用 FontAwesome）。
   */
  extend(User.prototype, 'badges', function (items) {
    if (!this.isScutVerified || !this.isScutVerified()) return;
    items.add('kapok-verified', m("span", {
      className: "Badge Badge--kapok-verified",
      title: tooltip(),
      "aria-label": tooltip()
    }, m("svg", {
      className: "MaterialIcon",
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true"
    }, m("path", {
      d: VERIFIED_PATH
    }))), 95);
  });

  /**
   * 用户设置页里的「学生认证」区块。
   */
  extend(SETTINGS_PAGE, 'settingsItems', function (items) {
    if (!app.session.user) return;
    items.add('kapok-verification', m(VerificationSection, null), 70);
  });
});